import { useTranslation } from "../../core/translation.core";
import useRetailShop from "../../hooks/useRetailShop";

export const profileGridCss = "grid grid-cols-1 md:grid-cols-[200px_200px] items-center";

export default function ProfileMe() {
  const { t, msg } = useTranslation();
  const data = useRetailShop();

  return (
    <section className="dark:text-white space-y-10">
      <div className={profileGridCss}>
        <span>{t(msg.setting.posShopName)}</span>
        <span id="span-email">{data?.name}</span>
      </div>

      <div className={profileGridCss}>
        <span>{t(msg.setting.posShopAddress)}</span>
        <span>{data?.address}</span>
      </div>
    </section>
  );
}
